<div class="assembly-order-closed-orders-table__wrapper">
  <ag-grid-angular
    class="ag-theme-alpine ag-theme-lum"
    style="width: 100%; height: 100%"
    [columnDefs]="columnDefs"
    [gridOptions]="gridOptions"
    (gridReady)="onGridReady($event)"
  ></ag-grid-angular>
</div>
